import React from "react";
import { Text, OrientationBloc } from "../../../../../components";
import {
  OrientationContainer,
  SubTitleContainer,
  TitleContainer,
  TextContainer,
  UnderlineText,
  ListContainer,
  List,
  BoldText,
  WarningText,
  InfoContainer,
} from "./styled-components";
import { ReactComponent as MailIcon } from "../../../../../assets/icons/mail.svg";
import { ReactComponent as BookIcon } from "../../../../../assets/icons/book.svg";
import { ReactComponent as CallIcon } from "../../../../../assets/icons/call.svg";

const options = [
  {
    icon: <MailIcon />,
    title: "",
    description: (
      <TextContainer>
        <Text size="18px">Vous pouvez nous saisir :</Text>
        <ListContainer>
          <ul>
            <li>
              <Text size="18px" lineHeight="28px">
                <BoldText>Par courrier postal </BoldText>gratuitement sans
                affranchissement en utilisant le système de{" "}
                <UnderlineText>double enveloppe</UnderlineText> :
                <br />
                <List>
                  <ul>
                    <li>
                      <Text weight={700} size="18px" lineHeight="28px">
                        Une enveloppe <UnderlineText>intérieure</UnderlineText>{" "}
                        contenant les éléments de votre alerte et portant
                        EXCLUSIVEMENT la mention suivante :{" "}
                      </Text>{" "}
                      <InfoContainer>
                        <Text weight={400} size="18px">
                          SIGNALEMENT D'UNE ALERTE
                        </Text>
                      </InfoContainer>
                    </li>
                    <li>
                      <Text weight={700} size="18px" lineHeight="28px">
                        Une enveloppe <UnderlineText>extérieure</UnderlineText>{" "}
                        avec l'adresse d'expédition :
                      </Text>
                      <InfoContainer>
                        Défenseur des droits <br />
                        Libre réponse 71120
                        <br />
                        75342 PARIS CEDEX 07
                      </InfoContainer>
                    </li>
                  </ul>
                </List>
              </Text>
            </li>
            <li>
              <Text size="18px" lineHeight="28px">
                <BoldText> En ligne, </BoldText>via le{" "}
                <a
                  href="https://formulaire.defenseurdesdroits.fr/code/afficher.php"
                  target="_blank"
                  rel="noreferrer"
                >
                  formulaire de saisine
                </a>
              </Text>
            </li>
          </ul>
        </ListContainer>
        <WarningText>
          <Text color="red" size="18px">
            *Pour une garantie maximale de confidentialité et de sécurité, nous
            vous conseillons de nous saisir par courrier postal.
          </Text>
        </WarningText>
      </TextContainer>
    ),
  },
  {
    icon: <CallIcon />,
    title: "",
    description: (
      <Text size="18px">
        Vous pouvez nous contacter par téléphone au{" "}
        <a href="tel:0969390000">09 69 39 00 00</a> du lundi au vendredi de 8h30
        à 19h30 (coût d'un appel local)
      </Text>
    ),
  },
  {
    icon: <BookIcon />,
    title: "",
    description: (
      <TextContainer>
        <Text size="18px">
          Si vous souhaitez en savoir plus sur la qualité de lanceur d’alerte,
          nous vous invitons à consulter le{" "}
          <a
            href="https://www.defenseurdesdroits.fr/fr/lanceurs-dalerte"
            target="_blank"
            rel="noreferrer"
          >
            guide du lanceur d’alerte
          </a>
        </Text>
      </TextContainer>
    ),
  },
];

const AlertePostiveResponse = () => {
  return (
    <>
      <TitleContainer>
        <Text size="40px" weight={700} lineHeight="52px" align="center">
          Il semblerait que le Défenseur des Droits <br />
          <span>soit en mesure de vous aider</span>
        </Text>
      </TitleContainer>
      <SubTitleContainer>
        <Text size="18px" align="center" color="grey400">
          Votre situation semble correspondre aux domaines de compétence du
          Défenseur des Droits. Vous pouvez dès maintenant suivre les
          informations ci-dessous afin que nous puissions répondre à votre
          alerte.
        </Text>
      </SubTitleContainer>
      <OrientationContainer>
        <OrientationBloc options={options} />
      </OrientationContainer>
    </>
  );
};

export default AlertePostiveResponse;
